var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxCircleCheck2 = function Svg18PxCircleCheck2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    className: "18px_circle-check-2_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.595 4.812-4.984 6.399a.75.75 0 0 1-.565.289H9.02a.75.75 0 0 1-.558-.248l-2.77-3.077a.751.751 0 0 1 1.116-1.004l2.17 2.412L13.559 3.7A6.96 6.96 0 0 0 9 2C5.141 2 2 5.14 2 9s3.141 7 7 7 7-3.14 7-7a6.95 6.95 0 0 0-1.405-4.188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.595 4.812 1.247-1.601a.75.75 0 1 0-1.184-.922L13.559 3.7c.385.331.731.705 1.036 1.111Z",
    "data-color": "color-2"
  }))));
};
export default Svg18PxCircleCheck2;